module.exports = __webpack_public_path__ + "static/media/icon_chevron_right.a4414612.svg";